import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';

var _createNamespace = createNamespace('loading'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    bem = _createNamespace2[0];

import {addUnit} from '../../common/utils/format';
export default {
    name: getComponentName('Loading'),
    data: function data() {
        return {};
    },
    props: {
        color: String,
        size: [Number, String],
        vertical: Boolean,
        textSize: [Number, String],
        textColor: String,
        type: {
            type: String,
            default: 'circular'
        }
    },
    methods: {
        getStyle: function getStyle() {
            var style = {};
            var color = this.color;
            var size = this.size;
            size = addUnit(size);
            style['height'] = size;
            style['width'] = size;
            style['color'] = color;
            return style;
        },
        getTextStyle: function getTextStyle() {
            var style = {};
            var color = this.color,
                textColor = this.textColor;
            var textSize = this.textSize;
            textSize = addUnit(textSize);
            style['fontSize'] = textSize;
            style['color'] = textColor || color;
            return style;
        }
    },
    render: function render() {
        var h = arguments[0];
        var type = this.type,
            vertical = this.vertical,
            getStyle = this.getStyle,
            getTextStyle = this.getTextStyle;
        var arr = new Array(12).fill(0);
        var slots = this.$slots;
        var style = getStyle();
        var textStyle = getTextStyle();
        return h(
            'div',
            {
                class: bem([
                    type,
                    {
                        vertical: vertical
                    }
                ])
            },
            [
                h(
                    'span',
                    {
                        class: bem('spinner', type),
                        style: style
                    },
                    [
                        type === 'spinner'
                            ? arr.map(function(item, index) {
                                  return h('i', {
                                      key: index
                                  });
                              })
                            : h(
                                  'svg',
                                  {
                                      class: bem('circular'),
                                      attrs: {
                                          viewBox: '25 25 50 50'
                                      }
                                  },
                                  [
                                      h('circle', {
                                          attrs: {
                                              cx: '50',
                                              cy: '50',
                                              fill: 'none',
                                              r: '20'
                                          }
                                      })
                                  ]
                              )
                    ]
                ),
                slots.default
                    ? h(
                          'span',
                          {
                              class: bem('text'),
                              style: textStyle
                          },
                          [slots.default[0]]
                      )
                    : ''
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
